import { useQuery } from "@apollo/client/react";
import { Box, Page } from "@nulogy/components";
import { GetVersion } from "hooks/apollo/version.gql";
import React from "react";

export default function Version() {
  const { data, loading } = useQuery(GetVersion);

  return (
    <Page>
      {loading && <Box>Loading...</Box>}
      {data && <Box>{data.version} </Box>}
    </Page>
  );
}
